module.exports = fox._r("images/lang/ru.png", __webpack_public_path__ + "_/_/_/common/frame/images/lang/ru.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/lang/ru.png
// module id = 111
// module chunks = 2